module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgBvZfbDcIwDEUdJukIXYENykSMwAjMwCZsACswwSURQYrURokT+1qK+vo4R1VsxwHAVUQeIYSnkCIzP+lmjeuVrkKIBM685f+CIrADFx9cBapgb4Em2EugG2wtoAZbCQyDZwWmwaMCZmCtgDm4V8AN3BJwB9cEaOADgTsVXAjc8ItNmFH86g2KNLQEL/mZcx6obS53gdaudhNAZzqZC0CZx2YCGCwg0wKYrFzDAjAqmWoBGNfqbgE4NYmmAJy7U1UApLa4E2CBjwROkqZFkXOcUt9CiDwNX+Jav3FNVHcWxowGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/close.png
// module id = AXD4
// module chunks = 1